import styled from 'styled-components';

export const LoadingContainer = styled.div<{ $isAnimating: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3d3d3d;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  transform: ${({ $isAnimating }) =>
    $isAnimating ? 'translateY(100%)' : 'translateY(0)'};
  transition: transform 0.5s ease-in-out;
`;

export const LoadingLogo = styled.img`
  width: 140px;
  position: absolute;
  top: 32px;
`;

export const LoadingContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const LoadingSpinnerContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 24px;
  background-color: #f7f4ee33;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  align-items: center;
`;

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 4px solid #e6dec9;
    background-color: transparent;
    animation: outerRipple 4s infinite;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 4px solid #ad9552;
    background-color: transparent;
    animation: innerGrow 4s infinite;
    z-index: 2;
  }

  @keyframes innerGrow {
    0% {
      width: 8px;
      height: 8px;
      border-color: #ad9552;
    }
    25% {
      width: 44px;
      height: 44px;
      border-color: #ad9552;
    }
    50% {
      width: 44px;
      height: 44px;
      border-color: #ad9552;
    }
    50.01% {
      width: 8px;
      height: 8px;
      border-color: #e6dec9;
    }
    75% {
      width: 44px;
      height: 44px;
      border-color: #e6dec9;
    }
    100% {
      width: 44px;
      height: 44px;
      border-color: #e6dec9;
    }
  }

  @keyframes outerRipple {
    0% {
      width: 44px;
      height: 44px;
      border-color: #e6dec9;
      transform: scale(1);
    }
    50% {
      width: 44px;
      height: 44px;
      border-color: #e6dec9;
      transform: scale(1.8);
    }
    50.01% {
      width: 44px;
      height: 44px;
      border-color: #ad9552;
      transform: scale(1);
    }
    100% {
      width: 44px;
      height: 44px;
      border-color: #ad9552;
      transform: scale(1.8);
    }
  }
`;
